import script from "./infoChangeMeal.vue?vue&type=script&setup=true&lang=js"
export * from "./infoChangeMeal.vue?vue&type=script&setup=true&lang=js"

import "./infoChangeMeal.vue?vue&type=style&index=0&id=24305a6a&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24305a6a"]])

export default __exports__